import React, { cache, useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import DateRange from "../../components/DateRange/DateRange";
import { useLocation } from "react-router-dom";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import Select from "react-select";
import { Search_icon, view_icon } from "../../assets/img";
import { Table } from "../../components/Table/Table";
import { checkPermission } from "../redux/api/PermissionManager";
import HttpClient from "../../Services/HttpClient";

export default function InvoiceUser() {
  const { paginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [count, setCount] = useState(0);
  const [locationList, setLocationsList] = useState({ states: [], cities: [] });
  const [state, setState] = useState(null);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [search, setSearch] = useState(paginationData?.[path]?.search ?? "");

  const [selectedFilter, setSelectedFilter] = useState(
    paginationData?.[path]
      ? { ...paginationData?.[path] }
      : { from: "", to: "" },
  );
  const handleChangeFilter = (name, val) => {
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };
  const getLocationsList = async (type, parent_id) => {
    let url = `${URLS.LOCATION}?type=${type}${
      parent_id ? `&parent_id=${parent_id}` : ""
    }`;
    const res = await get(url);
    if (res?.status === "success") {
      const modifiedList = res.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      if (type === 2)
        setLocationsList((prev) => ({ ...prev, states: modifiedList }));
      else if (type === 3)
        setLocationsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };
  useEffect(() => {
    getLocationsList(2);
  }, []);

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",

        Cell: ({ value, row }) => {
          return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "Invoice date",
        accessor: "invoice_date",
        Cell: ({ value, row }) => {
          return <p>{value || "-"}</p>;
        },
      },

      {
        Header: " Invoice Number",
        accessor: "invoice_number",
        Cell: ({ value, row }) => {
          return <p style={{ textAlign: "center" }}>{value || "-"}</p>;
        },
      },
      {
        Header: " GST No",
        accessor: "gst_no",
        Cell: ({ value, row }) => {
          return <p className="primary pointer">{value || "-"}</p>;
        },
      },
      {
        Header: "State",
        accessor: "state",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value || "-"}</p>;
        },
      },

      {
        Header: "Taxable Amount",
        accessor: "vow_amount_without_gst",
        Cell: ({ value, row }) => {
          return <p style={{ textAlign: "center" }}>{value || "-"}</p>;
        },
      },

      {
        Header: "GST Amount (18%)",
        accessor: "gst_amount",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap" style={{ textAlign: "center" }}>
              {value || "-"}
            </p>
          );
        },
      },
      {
        Header: "S-Gst (9%)",
        accessor: "sgst",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value || "-"}</p>;
        },
      },

      {
        Header: "C-Gst (9%)",
        accessor: "cgst",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value || "-"}</p>;
        },
      },

      {
        Header: " IGST Percent (18%)",
        accessor: "igst",
        Cell: ({ value, row }) => {
          return <p>{value || "-"}</p>;
        },
      },
      {
        Header: "Invoice Value",
        accessor: "vow_amount_with_gst",
        Cell: ({ value, row }) => {
          return <p>{value || "-"}</p>;
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-js gap-2">
              <button
                className={`
                active-btn p-2 w-100 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16`}
              >
                {value}
              </button>
            </div>
          );
        },
      },
    ];
    let action = {
      Header: "View",
      accessor: "booking_id",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              {checkPermission("CAN-VIEW-TRANSACTION") && (
                <button
                  // onClick={() => {
                  //   navigate("/booking-list-view", {
                  //     state: { type: "edit", booking_id: value },
                  //   });
                  // }}
                  className="cust-btn "
                >
                  <img src={view_icon} alt="" className=" edit-btn " />
                </button>
              )}
            </div>
          </React.Fragment>
        );
      },
    };
    return d;
    // return checkPermission("CAN-VIEW-TRANSACTION") ? [...d, action] : d;
  }, [page]);

  const fetchDatas = async (pageNumber = 1) => {
    try {
      let payload = {
        from_date: selectedFilter?.from,
        to_date: selectedFilter?.to,
      };
      if (search) {
        payload.booking_code = search;
      }

      if (state) {
        payload.state_id = state?.value;
      }
      const res = await post(
        `${URLS.INVOICE_USER}?page=${pageNumber}`,
        payload,
      );
      console.log("RRRRRRRRRRRRRR", res);

      if (res?.status === "success") {
        setData(res?.data);
        setCount(res?.count);
        setPagination({
          current_page: pageNumber,
          last_page: res?.total_pages,
        });
      }
    } catch (err) {
      console.log("INVOICE USER ", err);
    }
  };
  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) fetchDatas(page);
  }, [state, selectedFilter.from, selectedFilter.to, search, page]);

  const invoiceDownload = async () => {
    try {
      let payload = {
        from_date: selectedFilter?.from,
        to_date: selectedFilter?.to,
      };
      if (search) {
        payload.booking_code = search;
      }

      if (state) {
        payload.state_id = state?.value;
      }
      let res = await HttpClient.post(URLS.INVOICE_USER_DOWNLOAD, payload, {
        responseType: "blob",
      });
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "invoiceList.xlsx"; // file name
      link.click();

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("excel download failed:", error);
    }
  };
  console.log("DATTAAAA", data);

  return (
    <div>
      <Topbar header={"Invoice User"} />
      <div
        className="d-flex ac-jb mt-3 gap-1 flex-wrap mt-2"
        style={{ alignItems: "center" }}
      >
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{count}
        </h2>
        {checkPermission("CAN-VIEW-INVOICE_USER") && (
          <button
            onClick={() => invoiceDownload()}
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
          >
            Invoice Download
          </button>
        )}
      </div>
      <div className="d-flex ac-jb mt-3 gap-1 flex-wrap mt-2">
        <DateRange
          setFromDate={(date) => handleChangeFilter("from", date)}
          setToDate={(date) => handleChangeFilter("to", date)}
        />
        <div className="d-flex gap-2">
          <Select
            className="location-search"
            options={locationList?.states}
            value={state}
            onChange={(selected) => {
              setLocationsList((prev) => ({ ...prev, cities: [] }));
              // setFilters((prev) => ({
              //   ...prev,
              //   state: selected?.value || null,
              //   city: null,
              // }));
              //   if (selected?.value) getLocationsList(3, selected.value);
              setState(selected);
              //   setCity(null);
              setPage(1);
            }}
            isClearable
            placeholder={"State"}
          />
          <div>
            <div className="search-input">
              <input
                value={search}
                onChange={(e) => {
                  setPage(1);
                  setSearch(e.target.value);
                }}
                type="text"
                placeholder="Search"
                style={{ border: "none", width: "150px" }}
              />
              <img src={Search_icon} className="search" />
            </div>
            <p style={{ color: "#494949", paddingLeft: 10 }}>ex:VOWBP0XVRI</p>
          </div>
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={data}
        show={true}
      />
    </div>
  );
}
